'use strict';

/* globals angular */
var _ = require('lodash');
/**
 * UserStore
 */


var UserStore = function (Flux, Utils, ResourceHelper, IdentityService, IntercomService) {

  var STORE_NAME = 'UserStore';

  var initialized = false;
  var StoreUtil = Flux.Store;
  // var DispatcherUtil = Flux.Dispatcher;
  var loggedAtStart = null;

  // Events Emitted by this store
  var Events = {
    LogIn : true,
    Changed : true
  };

  var UserStore = StoreUtil.create({
    name: STORE_NAME,
    events: Events
  });

  UserStore.init = function () {
    if (!initialized) {
      initialized = true;
    }

    if (loggedAtStart === null) {
      loggedAtStart = !IdentityService.isAnonUser();
    }
  };

  UserStore.setUser = function(user) {
    this.$set('user', user);
    var orgWithRelated =  _.find(user.organizations, {id: IdentityService.getCurrentOrganization().id});
    var orgUsers = _.find(orgWithRelated.users, {id: IdentityService.getUser().id});

    if (orgUsers) {
      var orgUser = _.find(orgUsers.organizations, {id: IdentityService.getCurrentOrganization().id});
      var orgRoles = orgUser.roles;
      IntercomService.update({ 'Core_Last_Organization_Role': _.max(orgRoles, 'id').name }); // records this in intercom
    }

    UserStore.emit(UserStore.Events.Changed);
  };

  UserStore.findUser = function() {
    var UserResource = ResourceHelper.getResource('User');
    var userId = IdentityService.getUser().id;

    return UserResource.find(userId);
  };

  UserStore.updateUser = function(newData) {
    var UserResource = ResourceHelper.getResource('User');
    var userId = IdentityService.getUser().id;

    return UserResource.update(userId, newData);
  };

  UserStore.updatePassword = function(newData) {
    var UserResource = ResourceHelper.getResource('User');
    var userId = IdentityService.getUser().id;
    return UserResource.updatePassword(userId, newData);
  };

  UserStore.destroyMetaByKey = function destroyMetaByKey (key = '') {
    const UserResource = ResourceHelper.getResource('User');
    const user = IdentityService.getUser();
    const meta = _.find(user.meta, { key: key });

    return UserResource.destroyMeta(user.id, meta);
  };

  UserStore.wasLoggedAtStart = () => {
    return loggedAtStart;
  };

  //////////////////////////////////////////////////////////////////////////////
  // Event Handlers
  //////////////////////////////////////////////////////////////////////////////

  // UserStore.onSetLocation = function (action) {

  //   this.$set('location', action.location);

  //   // update url bar if on one of the location states... does not reload
  //   if ($state.includes('map.location')) {
  //     var locstr = Utils.Url.formatLocationToString(action.location);
  //     $state.transitionTo($state.$current.name, {
  //       location: locstr
  //     });
  //   }
  // };

  // UserStore.onResizeMap = function () {
  // //   var map = this.get('map');
  // //   map.invalidateSize({
  // //     pan: true,
  // //     debounceMoveend: true
  // //   });
  // };

  //////////////////////////////////////////////////////////////////////////////
  // Watchers
  //////////////////////////////////////////////////////////////////////////////
  // UserStore.watch('location', UserStore.Events.Changed, 'collection');

  return UserStore;
};

UserStore.$inject = ['sbFlux', 'Utils', 'ResourceHelper', 'IdentityService', 'IntercomService'];
module.exports = UserStore;



// WEBPACK FOOTER //
// ./src/app/dash/dataStores/UserStore.js